import { SelectCombobox } from 'components/combobox';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useStorageUnitsByPointQuery } from 'types/generated/graphql';

interface StorageUnitSelectProps {
  pointId?: string;
  selectedStorageUnitId: string | null;
  onSelect: (storageUnitId: string | null) => void;
  label?: string;
}

/**
 * Reusable Storage Unit select component
 * Fetches storage units for a given point and allows selection
 */
export function StorageUnitSelect({
  pointId,
  selectedStorageUnitId,
  onSelect,
  label,
}: StorageUnitSelectProps) {
  const { t } = useTranslation();
  const { data, isSuccess } = useStorageUnitsByPointQuery(
    { pointId: pointId! },
    { enabled: !!pointId }
  );
  const storageUnits = data?.storageUnitsByPoint ?? [];

  const selectedStorageUnit =
    storageUnits.find((su) => su.id === selectedStorageUnitId) ?? null;

  return (
    <Wrapper>
      <SelectCombobox
        items={isSuccess ? storageUnits : []}
        value={selectedStorageUnit}
        onChange={(unit) => onSelect(unit?.id ?? null)}
        getItemLabel={(unit) => (unit ? unit.name || unit.id : '')}
        getItemValue={(unit) => unit.id}
        label={label || t('Events.Filter.StorageUnit')}
        searchPlaceholder={t('Events.Filter.SearchStorageUnit')}
        emptyMessage={t('Events.Filter.StorageUnit.NoStorageUnits')}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 150px;
`;
